/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 企業住所
 * @export
 * @interface PostAccountSettingsItemAddress
 */
export interface PostAccountSettingsItemAddress {
    /**
     * 郵便番号
     * @type {string}
     * @memberof PostAccountSettingsItemAddress
     */
    zipCode?: string;
    /**
     * 都道府県
     * @type {string}
     * @memberof PostAccountSettingsItemAddress
     */
    prefecture?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof PostAccountSettingsItemAddress
     */
    city?: string;
}

export function PostAccountSettingsItemAddressFromJSON(json: any): PostAccountSettingsItemAddress {
    return PostAccountSettingsItemAddressFromJSONTyped(json, false);
}

export function PostAccountSettingsItemAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAccountSettingsItemAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zipCode': !exists(json, 'zip_code') ? undefined : json['zip_code'],
        'prefecture': !exists(json, 'prefecture') ? undefined : json['prefecture'],
        'city': !exists(json, 'city') ? undefined : json['city'],
    };
}

export function PostAccountSettingsItemAddressToJSON(value?: PostAccountSettingsItemAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zip_code': value.zipCode,
        'prefecture': value.prefecture,
        'city': value.city,
    };
}

